export default __webpack_public_path__ + "static/media/Group 1692.5eb6e016.png";